import React from 'react';
import DisabledCommentIcon from '@wix/da-ds/pkg/Icons/DisabledComment';
import classnames from 'classnames';

import s from './DisabledComment.scss';
export interface Props {
  className?: string;
  title: string;
}

const DisabledComment: React.FC<Props> = ({ className, title }) => {
  return (
    <div className={classnames(s['comments-disabled'], className)}>
      <DisabledCommentIcon />
      <span className={s['comments-disabled-text']}>{title}</span>
    </div>
  );
};

DisabledComment.displayName = 'DisabledComment';

export default DisabledComment;
